module.exports = __webpack_public_path__ + "img/Hexagon2.8225339a.png";